import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class OrganisationCustomerService extends RestfulService<Models.OrganisationCustomer> {

  constructor(public restService: RestService) {
    super(Models.OrganisationCustomer);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('organisation-customers');
  }

}
